import { authGuard } from '@pantheon-systems/auth0-vue-module'
import EmptyRouterView from '@/components/EmptyRouterView.vue'

export default [
  {
    path: '/private-keys',
    component: EmptyRouterView,
    children: [{
      path: '',
      name: 'private-keys',
      component: () => import('../views/PrivateKeys.vue')
    }, {
      path: 'upload',
      name: 'upload-key',
      component: () => import('../views/UploadKey.vue')
    }],
    beforeEnter: authGuard
  }
]
